import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
import { ENDORSEMENT_URL } from 'src/app/_common/constants';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { PolicyService } from 'src/app/_services/policy.service';

@Injectable({
  providedIn: 'root'
})

export class EndorsementService {

  private _endorsement;
  private _selectedStep: string; //Using it in HTML

  private supportingDocuments = [];

  constructor(private http: HttpClient, private policyService: PolicyService, private commonService: CommonService) {

  }

  set header(data){
    this.commonService.header = data;
  }
  get runningServices(){
    return this.commonService.runningServices;
  }

  addSupportingDocument(_document){
    this.supportingDocuments.push(_document);
  }

  getSupportingDocuments(){
    return this.supportingDocuments;
  }
  setSupportingDocuments(_documents){
    this.supportingDocuments = _documents;
  }

  getLoggedInProfile(){
    return this.commonService.getData().currentUser;
  }

  getPolicyData(){
    return this.policyService.getPolicyData();
  }
  storePolicyData(policy){
    this.policyService.storePolicyData(policy);
  }

  getAccountData(){
    return this.policyService.getAccountData();
  }  
  storeAccountData(account){
    this.policyService.storeAccountData(account);
  }

  fetchAccountByPolicy(policyNumber){
    return this.commonService.fetchAccountByPolicy(policyNumber);
  }

  getEndorsementData(){
    let psiData = this.commonService.getData();
    return psiData.endorsement;
  }  

  storeEndorsementData(_endorsement){
    let psiData = this.commonService.getData();
    psiData.endorsement = _endorsement;
    this.commonService.storeData(psiData);
  }  

  /* ENDORSEMENT API */
  fetchEndorsements(accountNumber, policyNumber){
    return this.http.get<any>(ENDORSEMENT_URL.Endorsements+"?accountNumber="+accountNumber + "&policyNumber="+policyNumber, {observe: 'response'})
        .pipe(map(polices => {
            return polices.body.result;
        }));
  }
  fetchPolicyLob(policyNumber){
    return this.policyService.fetchPolicyLob(policyNumber);
  }
  submitEndorsement(policyNumber, data){
    return this.http.post<any>(ENDORSEMENT_URL.SubmitEndorsement+"?policyNumber="+policyNumber, data, {observe: 'response'})
      .pipe(map(response => {
        return response.body.result;
    }));
  }

  get endorsement(){
    if(!this._endorsement){
      this._endorsement = this.getEndorsementData();
    }
    return this._endorsement;
  }
  set endorsement(_endorsement){
    this._endorsement = _endorsement;
    this.storeEndorsementData(_endorsement);
  }
  get selectedStep():string{
    if(!this._endorsement){
      this._endorsement = this.getEndorsementData();
    }
    return this._endorsement.selectedStep;
  }
  set selectedStep(_step){
    this._endorsement.selectedStep = _step;
    this._selectedStep = _step;
    this.storeEndorsementData(this._endorsement);
  }

}
